import { createContext } from 'react';
import { IObservableArray, observable } from 'mobx';
import PortalDataSourceQuery from '../DataSource/PortalDataSourceQuery';

export const OpenPortalQueries = observable.array<PortalDataSourceQuery>();

export default createContext<IObservableArray<PortalDataSourceQuery>>(OpenPortalQueries);
